var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex"}},[_c('AdminHeader',{attrs:{"menu_id":'4-4'}}),_vm._v(" "),_c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"0"},attrs:{"src":"/tms/","loading":"lazy"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645df6fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/TravelManagement/AdminTmsManagement.vue
// module id = null
// module chunks = 